'use strict';

angular.module('mean.invoices').factory('invoiceNumberService', ['$filter', 'Invoices', 'toaster', '$q', 'aceUtils',
    function($filter, Invoices, toaster, $q, aceUtils) {
        var month = 0;
        var year = 0;
        var getNext = function(company_code, trade_code, startDate, endDate) {
            var deferred = $q.defer();
            var monthbegin = aceUtils.padDigits(moment(startDate).month()+1, 2); 
            var monthend = aceUtils.padDigits(moment(endDate).month()+1, 2); 
            if(monthbegin !== monthend) {
                toaster.pop('error', 'Date Range Selection',
                    'Start and end dates should be in the same month');
                return;
            }
            month = monthbegin;
            year = moment().year();

            //'type': 'NumbersOnly'
            Invoices.query({'company_code': company_code, 'trade_code': trade_code, 
                'month': month, 'year': year }, function(invoices) {
                

                var modifier = '';
                if(invoices.length) {
                    //we already have a generated invoice for this month
                    //might need to return an error in the future but for
                    //now add a modifier to the returned string
                    modifier = '-' + invoices.length
                }
                
                var invoice_string = year + '-' + month + modifier;
                deferred.resolve(invoice_string);
            });

            return deferred.promise;
        }
        
        return {
            getNext: getNext
        };
    }
]);


// WEBPACK FOOTER //
// ./packages/custom/invoices/public/services/invoice-number-service.js